module.exports = __webpack_public_path__ + "images/application/templates/layout-basic-88e57f35.png";